import {
    Component,
    Input,
} from '@angular/core';

/** Componente label. */
@Component({
    selector: 'ndd-ng-form-label',
    template: require('./ndd-ng-form-label.component.html'),
})
export class NDDFormLabelComponent {
    /** Id (do controle a qual esta label refere-se) para o atributo `for`. */
    @Input() public controlForId: string;
    /** Texto da label. */
    @Input() public controlLabel: string;
    /** Define se o controle referenciado é obrigatório. */
    @Input() public controlRequired: boolean;
}
